export const getLocationFromString = (input: string | undefined): number[] => {
  return (input ?? '0,0').split(',').map(parseFloat);
};
